import { render } from "./FinishJoin.vue?vue&type=template&id=22f15228&scoped=true"
import script from "./FinishJoin.vue?vue&type=script&lang=js"
export * from "./FinishJoin.vue?vue&type=script&lang=js"

import "./FinishJoin.vue?vue&type=style&index=0&id=22f15228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f15228"]])

export default __exports__